import {
  KgInsightMention,
  KgInsightMentionsRequest,
  KgInsightMentionsResponse,
  kgInsights,
} from '@api/api/kg-insights';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';
import { startOfDay, subDays } from 'date-fns';

export const QUERY_KEY_THEME_MENTIONS = 'QUERY_KEY_THEME_MENTIONS';

export const MENTIONS_WINDOW_DAYS = 30;

const PAGE_SIZE = 500;

export const fetchAllMentions = async (
  themeId: string,
  signal: AbortSignal | undefined
): Promise<KgInsightMentionsResponse> => {
  const to = new Date();
  const from = startOfDay(subDays(to, MENTIONS_WINDOW_DAYS));
  const mentions: KgInsightMention[] = [];

  for (let page = 1; ; page++) {
    const body: KgInsightMentionsRequest = {
      subject_type: 'theme',
      subject_id: themeId,
      from: from.toISOString(),
      to: to.toISOString(),
      page,
      page_size: PAGE_SIZE,
    };

    const response = await wretchRequest<KgInsightMentionsResponse>(
      kgInsights.postKgInsightMentions.path,
      {
        method: 'post',
        body,
        schema: kgInsights.postKgInsightMentions.schema,
        signal,
      }
    );

    mentions.push(...response.mentions);

    if (response.mentions.length < PAGE_SIZE) {
      break;
    }
  }

  return { mentions };
};
